import { useContext } from "react";
import { WithQueryConfigContext } from "./context";

export const WithQueryConfig = WithQueryConfigContext.Provider;

export const useWithQueryConfig = () => useContext(WithQueryConfigContext);
